import { render } from "./Status.vue?vue&type=template&id=22e88345&scoped=true&ts=true"
import script from "./Status.vue?vue&type=script&lang=ts"
export * from "./Status.vue?vue&type=script&lang=ts"

import "./Status.vue?vue&type=style&index=0&id=22e88345&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e88345"]])

export default __exports__